import { useAdminApi } from '@components/providers/AdminApiProvider';
import { useAdminStore } from '@store/adminStore';
import { useEffect, useRef, useState } from 'react';

type AdminSessionInitState = {
  isLoading: boolean;
  isReady: boolean;
  error: Error | null;
};

function useAdminSessionInit(): AdminSessionInitState {
  const { server } = useAdminApi();
  const sessionReady = useAdminStore((s) => s.user.sessionReady);

  const [isLoading, setIsLoading] = useState(!sessionReady);
  const [error, setError] = useState<Error | null>(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (sessionReady) return;
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;

    server
      .refreshSelf()
      .then(() => {
        setIsLoading(false);
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err : new Error(String(err)));
        setIsLoading(false);
      });
  }, [sessionReady, server]);

  return {
    isLoading: sessionReady ? false : isLoading,
    isReady: sessionReady,
    error,
  };
}

export type { AdminSessionInitState };
export { useAdminSessionInit };
